module.exports = __webpack_public_path__ + "static/media/campus_30.66043dbd.jpg";